import { ColumnConfig } from '@components/design/migrated/Table';
import React from 'react';
import { PerformanceAnalysisboardPg } from '@models/PerformanceAnalysisboard';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import PerformanceAnalysisTableRow from '../performance-analysis-table-row/PerformanceAnalysisTableRow';
import { Filters, ShareType } from '@utils/pageConfig/Types';

interface Props {
  performanceAnalysisboardPg: PerformanceAnalysisboardPg;
  columns: ColumnConfig[];
  sortedColumn: string;
  selectedGrowthType: GrowthTypes;
  selectedShareType: ShareType;
  countries: Filters;
  currencySymbol: string;
}

export const PerformanceAnalysisTableHead: React.FC<Props> = ({
  performanceAnalysisboardPg,
  columns,
  sortedColumn,
  selectedGrowthType,
  selectedShareType,
  countries,
  currencySymbol,
}) => {
  return (
    <tbody>
      <PerformanceAnalysisTableRow
        key={'Total'}
        performanceAnalysisboardPg={performanceAnalysisboardPg}
        columns={columns}
        isStickyRow={true}
        sortedColumn={sortedColumn}
        selectedGrowthType={selectedGrowthType}
        selectedShareType={selectedShareType}
        countries={countries}
        currencySymbol={currencySymbol}
      />
    </tbody>
  );
};

export default PerformanceAnalysisTableHead;
